import { UppFloorPlanFurniture } from '../../floor-plan-element';
import type { FloorPlanAreaSourceDrawPieceItem, UppKonvaShape } from '../floor-plan-wire-types';
import { elementOptsFromLabels, sofaShapeFromDrawItemShape } from './shape-bridge-helpers';
import type { FloorPlanShapeBridge, SourceToWireInput } from './shape-bridge-types';

function adapterRowLabels(row: UppKonvaShape): {
  label?: string;
  sublabel?: string;
  zIndex?: number;
  custom?: unknown;
} {
  const o: { label?: string; sublabel?: string; zIndex?: number; custom?: unknown } = {};
  if ('label' in row && row.label !== undefined) {
    o.label = row.label;
  }
  if ('sublabel' in row && row.sublabel !== undefined) {
    o.sublabel = row.sublabel;
  }
  if ('zIndex' in row && row.zIndex !== undefined) {
    o.zIndex = row.zIndex;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'custom')) {
    o.custom = (row as { custom?: unknown }).custom;
  }
  return o;
}

export const sofaShapeBridge: FloorPlanShapeBridge = {
  kind: 'SOFA',
  wireType: 'SOFA',
  sourceToWire(i: SourceToWireInput): UppKonvaShape {
    const fs = String(i.d['shape'] ?? 'LINEAR').toUpperCase();
    const furnitureShape = fs === 'TOLEFT' || fs === 'TORIGHT' ? fs : 'LINEAR';
    const p: FloorPlanAreaSourceDrawPieceItem = {
      type: 'SOFA',
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height,
      rotation: i.rotation,
      ...(furnitureShape !== 'LINEAR' ? { furnitureShape } : {}),
      ...(i.id.uuid ? { uuid: i.id.uuid } : {}),
      ...i.lb,
    };
    return { ...p, ...(!i.id.uuid ? { id: i.id.id } : {}) } as UppKonvaShape;
  },
  wireToSource(row: UppKonvaShape) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const uuid = r.uuid !== undefined && r.uuid.trim() !== '' ? r.uuid.trim() : '';
    const legacyId = 'id' in row && typeof (row as { id?: unknown }).id === 'string' ? String((row as { id: string }).id) : '';
    const id = uuid || legacyId || 'shape-SOFA';
    const base = {
      id,
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      rotation: r.rotation,
      ...adapterRowLabels(row),
    };
    return {
      ...base,
      kind: 'SOFA',
      data: { shape: r.furnitureShape ?? 'LINEAR' },
    };
  },
  wireToElement(row: UppKonvaShape, uuid: string) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const { x, y, width, height, rotation } = r;
    const opt = elementOptsFromLabels(r, false);
    const el = new UppFloorPlanFurniture(
      uuid,
      x,
      y,
      width,
      height,
      rotation,
      'sofa',
      undefined,
      opt,
      sofaShapeFromDrawItemShape(r.furnitureShape),
    );
    el.zIndex = r.zIndex ?? 0;
    return el;
  },
};
